import styled from "styled-components";
import Typography from "../../designComponents/Typography";
import { AddButton } from "./styles";

export interface PaymentMethodType {
  title: string;
  key: string;
  icon: string;
  adminId: string;
  isActive: boolean;
  _id: string;
}

interface ViewPaymentMethodProps {
  data: PaymentMethodType[];
  onDeleteClick: (id: string) => void;
  onEditClick: (values: PaymentMethodType) => void;
  onAddClick: VoidFunction;
}
interface PaymentMethodCardProps {
  title: string;
  key: string;
  icon: string;
  adminId: string;
  isActive: boolean;
  onDeleteClick: () => void;
  onEditClick: () => void;
}
const CardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 16px;
  margin-bottom: 12px;
`;

const Info = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 4px;
  }
`;

const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const StatusBadge = styled.span<{ active: boolean }>`
  display: inline-block;
  font-size: 0.75rem;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 500;
  color: ${({ active }) => (active ? "#166534" : "#7f1d1d")};
  background: ${({ active }) =>
    active ? "rgba(22, 101, 52, 0.1)" : "rgba(124, 58, 58, 0.1)"};
`;

const Actions = styled.div`
  display: flex;
  gap: 8px;
`;

const IconButton = styled.button<{ hoverColor: string }>`
  font-size: 0.875rem;
  padding: 6px 14px;
  border: 1px solid #4b5563;
  background-color: transparent;
  color: #4b5563;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;

  &:hover {
    background-color: ${({ hoverColor }) => hoverColor};
    color: white;
  }
`;
export const PaymentMethodCard: React.FC<PaymentMethodCardProps> = ({
  icon,
  isActive,
  onDeleteClick,
  onEditClick,
  title,
}) => (
  <CardContainer>
    <Info>
      <IconWrapper>
        <img src={icon} alt={title} />
      </IconWrapper>

      <TextGroup>
        <Typography variant="h6">{title}</Typography>
        <StatusBadge active={isActive}>
          {isActive ? "Active" : "Inactive"}
        </StatusBadge>
      </TextGroup>
    </Info>

    <Actions>
      <IconButton
        hoverColor="#0000FF"
        onClick={() => onEditClick()}
        title="Edit"
      >
        Edit
      </IconButton>
      <IconButton
        hoverColor="#ff0000"
        onClick={() => onDeleteClick()}
        title="Delete"
      >
        Delete
      </IconButton>
    </Actions>
  </CardContainer>
);

function ViewPaymentMethods({
  data,
  onDeleteClick,
  onEditClick,
  onAddClick,
}: ViewPaymentMethodProps) {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <p>Payment methods</p>
        <AddButton onClick={onAddClick}>Add</AddButton>
      </div>
      {data?.length === 0 && (
        <Typography>No Payment Methods Found !</Typography>
      )}
      {data?.map((item, index) => {
        return (
          <PaymentMethodCard
            key={item._id}
            adminId={item.adminId}
            icon={item.icon}
            isActive={item.isActive}
            title={item.title}
            onDeleteClick={() => {
              onDeleteClick(item._id);
            }}
            onEditClick={() => {
              onEditClick(item);
            }}
          />
        );
      })}
    </div>
  );
}

export default ViewPaymentMethods;
